import { IDeleteOcorrenciaInspecaoPatrimonioUseCase } from "../../../presentation/useCases/delete/delete_ocorrencia_inspecao_patrimonio_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DeleteOcorrenciaInspecaoPatrimonioUseCase
 */

export class DeleteOcorrenciaInspecaoPatrimonioUseCase implements IDeleteOcorrenciaInspecaoPatrimonioUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async deleteOcorrenciaInspecaoPatrimonio(
    idOcorrenciaInspecaoPatrimonio: number
  ): Promise<void> {
    await this.repository.deleteOcorrenciaInspecaoPatrimonio(idOcorrenciaInspecaoPatrimonio);
  }
}
